import httpClient from "Api/httpClient";

const END_POINT = "/sql/fields";

const getSqlFields = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getSqlField = (field_id) => {
    if (!field_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + field_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printSqlField = (field_id) => {
    if (!field_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?field_id=" + field_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createSqlFields = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateSqlFields = (payload, field_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + field_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteSqlFields = (field_id) => {
    const DELETE_END_POINT = END_POINT + "/" + field_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getSqlFields, getSqlField, printSqlField, createSqlFields, updateSqlFields, deleteSqlFields };
